var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2199_78923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 3.63889L5.99998 6M5.99998 6L1.74998 3.63889M5.99998 6L6 10.75M10.5 8.02929V3.97073C10.5 3.79941 10.5 3.71375 10.4748 3.63735C10.4524 3.56976 10.4159 3.50772 10.3677 3.45538C10.3132 3.39621 10.2383 3.35461 10.0885 3.27141L6.38852 1.21585C6.24671 1.13707 6.17581 1.09768 6.10073 1.08224C6.03427 1.06857 5.96573 1.06857 5.89928 1.08224C5.82419 1.09768 5.75329 1.13707 5.61149 1.21585L1.91149 3.27141C1.76172 3.35461 1.68684 3.39621 1.63232 3.45538C1.58408 3.50772 1.54757 3.56977 1.52524 3.63735C1.5 3.71375 1.5 3.79941 1.5 3.97074V8.02929C1.5 8.20061 1.5 8.28627 1.52524 8.36267C1.54757 8.43026 1.58408 8.4923 1.63232 8.54464C1.68684 8.60381 1.76172 8.64541 1.91149 8.72861L5.61149 10.7842C5.75329 10.8629 5.82419 10.9023 5.89928 10.9178C5.96573 10.9314 6.03427 10.9314 6.10073 10.9178C6.17581 10.9023 6.24671 10.8629 6.38851 10.7842L10.0885 8.72861C10.2383 8.64541 10.3132 8.60381 10.3677 8.54464C10.4159 8.4923 10.4524 8.43026 10.4748 8.36267C10.5 8.28627 10.5 8.20061 10.5 8.02929Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2199_78923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.5aa443ac7cdcbbcca30098e44764d057.svg";
export { ForwardRef as ReactComponent };